module.exports = __webpack_public_path__ + "img/close.b6a70bc9.svg";